const SupplierContract = ({ data }) => {
    return (
        <>
            <p style={{ fontSize: "1.2rem", fontWeight: "600", padding: "1rem 0rem 1rem 0rem" }}>{data?.name}</p>
            <p className="sub-title">{data?.description}</p>
            {data?.feeComponents?.length ? (
                <>
                    <p style={{ fontSize: "1.2rem", fontWeight: "600", padding: "1rem 0rem 1rem 0rem" }}>Fee components</p>
                    <div className="table-wrapper" style={{ height: "auto", maxHeight: "unset" }}>
                        <table>
                            <thead>
                                <tr>
                                    <th>name</th>
                                    <th>status</th>
                                    <th>subContractFeeSchedType</th>
                                    <th>subContractType</th>
                                    <th>description</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.feeComponents.map((r, i) => (
                                    <tr key={'fc' + (r.key || i)}>
                                        <td>{r.name}</td>
                                        <td>{r.status}</td>
                                        <td>{r.subContractFeeSchedType}</td>
                                        <td>{r.subContractType}</td>
                                        <td>{r.description}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </>
            ) : (
                <p className="sub-title">No fee components linked to this contract.</p>
            )}
            {data?.benefitNetworks?.length ? (
                <>
                    <p style={{ fontSize: "1.2rem", fontWeight: "600", padding: "1rem 0rem 1rem 0rem" }}>Benefit networks</p>
                    <div className="table-wrapper" style={{ height: "auto", maxHeight: "unset" }}>
                        <table>
                            <thead>
                                <tr>
                                    <th>name</th>
                                    <th>status</th>
                                    <th>subContractType</th>
                                    <th>description</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.benefitNetworks.map((r, i) => (
                                    <tr key={'bn' + (r.key || i)}>
                                        <td>{r.name}</td>
                                        <td>{r.status}</td>
                                        <td>{r.subContractType}</td>
                                        <td>{r.description}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </>
            ) : (
                <p className="sub-title">No benefit networks linked to this contract.</p>
            )}
        </>
    );
};

export default SupplierContract;
